<template>
  <section>
    <v-tabs v-model="modelGroup">
      <v-tabs-slider></v-tabs-slider>

      <v-tab v-for="item in items" :key="item.title">
        {{ item.title }}
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="modelGroup">
      <v-tab-item v-for="item in items" :key="item.title">
        <v-card flat>
          <v-card-text v-text="item.description"></v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </section>
</template>

<script>
export default {
  data: () => ({
    items: [
      {
        title: "Standard Model",
        description:
          "The Standard Model includes sCJD and faster progressing IPD groups (E200K, 4OPRI, D178N, E196Q, E211Q, V201I)."
      },
      {
        title: "Slow Model",
        description:
          "The Slow Model includes vCJD and slower progressing IPD groups (P102L, 5OPRI, 6OPRI, A117V, P105L, Y163X, 8OPRI, Q212P, E196K)."
      },
      {
        title: "Iatrogenic Model",
        description:
          "The Iatrogenic model only includes iatrogenic patients, who progress more slowly than the standard group but have a progression rate influenced by codon 129."
      }
    ]
  }),
  computed: {
    modelGroup: {
      get() {
        return this.$store.state.modelGroupTab;
      },
      set(value) {
        this.$store.state.modelGroupTab = value;
      }
    }
  }
};
</script>
